import { useLoading } from "../../context/LoadingContext";
import "./loading.css";

export default function LoadingOverlay() {
  const { loading } = useLoading();

  if (!loading) return null;

  return (
    <div className="loading-overlay">
      <div className="spinner" />
    </div>
  );
}
